import React, { useEffect, useState } from 'react'

import { Box } from '@mui/material'
import { Loader } from '~/shared/ui'
import { useAuth0 } from '@auth0/auth0-react'
import { fireAndForget } from '~/shared/lib/fireAndForget'
import { requireAccessToken } from '~/shared/lib/auth'

interface Props {
  formSubmission: { id: number; form: { id: number } }
}

/*
Displays a FormSubmission using a WebView of our forms engine app
*/
const EmbeddedFormSubmission: React.FC<Props> = props => {
  const [session, setSession] = useState<null | { accessToken: string }>(null)
  const { getAccessTokenSilently } = useAuth0()
  const [iFrameRef, setIFrameRef] = useState<HTMLIFrameElement | null>(null)

  useEffect(() => {
    fireAndForget('[Forms] fetch embed access token', () =>
      getAccessTokenSilently().then(token =>
        setSession({ accessToken: requireAccessToken(token) }),
      ),
    )
  }, [getAccessTokenSilently])

  const webViewUrlBase = import.meta.env.VITE_FIREFLY_FORMS_UI_URL

  const formId = props.formSubmission.form.id
  const submissionId = props.formSubmission.id
  const webViewUrl = `${webViewUrlBase}/${formId}/responses/${submissionId}`

  const injectToken = () => {
    if (!session) return
    iFrameRef?.contentWindow?.postMessage(
      { type: 'setToken', body: { token: session.accessToken, isProvider: true } },
      webViewUrlBase,
    )
  }

  return (
    <Box sx={{ flex: 1, overflow: 'auto' }}>
      {session?.accessToken ? (
        <iframe
          ref={setIFrameRef}
          title="Form Submission"
          id="form-submission"
          width="100%"
          height={window.innerHeight * 0.8}
          style={{ padding: 10, border: 'none' }}
          onLoadCapture={injectToken}
          src={webViewUrl}
        />
      ) : (
        <Loader inline />
      )}
    </Box>
  )
}

export default EmbeddedFormSubmission
